/* PackageListComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PackageListRenderer");
const _ = require("lodash");

class PackageListComponent extends EventEmitter {
    constructor(packages) {
        super();
        this._renderer = new Renderer(this);

        this._registerListeners();
        this.setPackages(packages);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._packages = undefined;
            this._renderer = undefined;
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    set packages(pkgs) {
        return this.setPackages(pkgs);
    }
    setPackages(pkgs, silent) {
        let old = _.cloneDeep(this.packages);
        this._packages = pkgs;
        if (!silent) {
            this.emit("PackagesReplaced", this._packages, old);
        }
        return this;
    }
    get packages() {
        return this.getPackages();
    }
    getPackages() {
        return this._packages;
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /* START PUBLIC API ACTION METHODS */
    /*******************************************/
    launchEditor(editorState, editorName, opts) {
        this.emit("LaunchEditor", editorState, editorName, opts);
    }
    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /*******************************************/
}
module.exports = PackageListComponent;
